export * from "./areas-details-summary";
